import Loadable from "react-loadable";
import LoadingComponent from "../../../../commons/loader"

export default [
  {
    path: "/clients/:customer_id/company/:company_id/financial-model",
    exact: true,
    auth: true,
    component: Loadable({
      loader: () => import("./pages/index"),
      loading: LoadingComponent
    })
  }
]


// WEBPACK FOOTER //
// ./src/modules/company/pages/financial-model/routes.js